import * as React from 'react';
import { compose, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin, OemProps } from 'ui/styles/skin';

import './Button.css';

export type OwnProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    textKey?: string;
    titleKey?: string;
};

export const RawButton = ({ textKey, titleKey, title, t, children, ...props }: OwnProps & TranslateProps & RecomposeProps) =>
    <button
        type="button"
        { ...props }
        className={ `button ${props.className || ''}` }
        title={ titleKey ? t(titleKey) : title }
    >
        { textKey ? t(textKey) : children }
    </button>
;

type RecomposeProps = {
    style: {};
};

export const Button = compose<OwnProps & RecomposeProps & TranslateProps, OwnProps>(
    translate(),
    skin,
    withProps(({ style = {}, styles }: OemProps & React.ButtonHTMLAttributes<HTMLButtonElement>) => ({
        style: {
            ...styles.Button,
            ...style,
        },
    })),
    // TODO: omit props "i18n" and "styles"
)(RawButton);


// WEBPACK FOOTER //
// ./src/ui/shared/Button.tsx